import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from 'react';
import { DURATION_TRANPOSRT, TOURIST_SERVICE_TYPE } from '../../../shared/constants';
import { splitField, splitFieldForms } from '../../../shared/utils';
import serviceDetailBaseStyles from '../../../styles/atoms/service-detail-base.module.scss';
import { GeneralConfigContext } from '../../general-config-provider';
import { StartFinishView } from '../../start-finish-view';
import ServicesListFormField from '../services-list-form-field';
import StopoverFormField from '../stopover-form-field';

type TransportPreviewProps = {
  detailData: any;
};

export const TransportPreview: FunctionComponent<TransportPreviewProps> = ({
  detailData,
}) => {
  const { generalConfig } = useContext(GeneralConfigContext);
  const router = useRouter();
  const [locale, setLocale] = useState(router?.locale);
  const t = useTranslations('viewOffer');
  useEffect(() => {
    if (router.locale) {
      setLocale(router?.locale);
    }
  }, [router?.locale]);
  return (
    <div className={serviceDetailBaseStyles.detailContainer}>
      <p>
        {t('tipoViaje')}{' '}
        <strong>
          {locale === 'en'
            ? generalConfig?.tipo_viaje.find(
                (type) => type.id_tipo_viaje === detailData.id_tipo_viaje
              ).en_nombre
            : generalConfig?.tipo_viaje.find(
                (type) => type.id_tipo_viaje === detailData.id_tipo_viaje
              ).nombre}
        </strong>
      </p>

      <p>
        {t('tipoVehiculo')}{' '}
        <strong>
          {locale === 'en'
            ? generalConfig?.tipo_vehiculo.find(
                (type) => type.id_tipo_vehiculo === detailData.id_tipo_vehiculo
              ).en_nombre
            : generalConfig?.tipo_vehiculo.find(
                (type) => type.id_tipo_vehiculo === detailData.id_tipo_vehiculo
              ).nombre}
        </strong>
      </p>

      <div className={serviceDetailBaseStyles.field}>
        <p>{t('recorrido')}</p>
        <StartFinishView
          points={[
            detailData.punto_transporte.find(
              (point) => point.tipo === 'salida'
            ),
            detailData.punto_transporte.find(
              (point) => point.tipo === 'llegada'
            ),
          ]}
        />
      </div>

      <div className={serviceDetailBaseStyles.field}>
        <p>{t('escalas')}</p>
        <StopoverFormField
          id_historico={1}
          version={2}
          offerID={4}
          transportID={detailData.id_transporte}
          value={detailData.punto_transporte}
          viewOnly={true}
        />
      </div>

      <p>
        {t('duracion')} <strong> {Number(detailData.duracion) === 4 && (<>
        {t('mas')}
        </>)} {DURATION_TRANPOSRT[(Number(detailData.duracion) - 1)]} {t('horas')}</strong>
      </p>

      {splitField(detailData.recomendaciones, locale) != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('recomendacioneSeguridad')}</p>
          <p>{splitField(detailData.recomendaciones, locale)}</p>
        </div>
      )}

      {splitField(detailData.restriciones, locale) != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('restrincciones')}</p>
          <p>{splitField(detailData.restriciones, locale)}</p>
        </div>
      )}

      <div className={serviceDetailBaseStyles.field}>
        <p>{t('incluye')}</p>
        <ServicesListFormField
          value={detailData?.servicio_adicional_transporte}
          viewOnly={true}
          touristServiceType={TOURIST_SERVICE_TYPE.TRANSPORT}
        />
      </div>
    </div>
  );
};
